<template>
  <vue-tel-input
    ref="telInput"
    v-model="computedValue"
    :autoDefaultCountry="false"
    :defaultCountry="defaultCountry"
    :inputOptions="inputOptions"
    :preferredCountries="['US']"
    :validCharactersOnly="true"
    @blur="$emit('handleBlur', $event)"
  ></vue-tel-input>
</template>

<script>
export default {
  name: "PhoneInput",
  props: ["value", "defaultCountry"],
  data() {
    return {
      inputOptions: {
        placeholder: "Enter the phone number",
        showDialCode: true,
        styleClasses: "form-control"
      }
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value || "+1";
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  watch: {
    computedValue: {
      handler(dialCode) {
        const dialc = this.$refs.telInput.allCountries.filter(
          country => country.dialCode === dialCode.substr(1)
        );
        if (dialc.length > 0) {
          this.$refs.telInput.choose(
            dialc.filter(
              item => item.iso2 === this.$refs.telInput.preferredCountries[0]
            ).length > 0
              ? "US"
              : dialc[0].iso2
          );
        }
      },
      deep: true
    }
  }
};
</script>

<style></style>
